import { Component } from '@angular/core';

@Component({
  selector: 'mprd-epress-skeleton',
  templateUrl: './epress-skeleton.component.html',
  styleUrls: ['./epress-skeleton.component.css'],
})
export class EpressSkeletonComponent {
  constructor() {}
}
